import {
  CANDIDATE_LIST,
  CANDIDATE_LIST_SUCCESSFUL,
  CANDIDATE_LIST_FAILED,
  CANDIDATE_SEARCH,
  CANDIDATE_SEARCH_SUCCESSFUL,
  CANDIDATE_SEARCH_FAILED,
  CANDIDATE_DELETE,
  CANDIDATE_DELETE_FAILED,
  CANDIDATE_DELETE_SUCCESSFUL,
  CANDIDATE_SEARCHLIST,
  CANDIDATE_SEARCHLIST_SUCCESS,
  CANDIDATE_SEARCHLIST_ERROR,
  GET_SEARCH_DATA,
  GET_SEARCH_CANDIDATE_DATA,
  GET_MAPPED_CANDIDATE_DATA,
  GET_SEARCH_MAPPED_CANDIDATE_DATA,
  GET_SEARCH_FILTER_CANDIDATE_DATA,
  GET_TABLE_SEARCH_FILTER,
  GET_SEARCH_SUGGESTION_DATA,
  GET_SEARCH_TABLE_SUGGESTION_DATA,
  GET_SEARCH_SUGGESTION_DATA_SUCCESS,
  GET_SEARCH_SUGGESTION_DATA_ERROR
} from "./actionTypes"

export const candidateList = user => {
  return {
    type: CANDIDATE_LIST,
    payload: { user },
  }
}

export const candidateListSuccessful = user => {
  return {
    type: CANDIDATE_LIST_SUCCESSFUL,
    payload: user,
  }
}

export const candidateListFailed = user => {
  return {
    type: CANDIDATE_LIST_FAILED,
    payload: user,
  }
}
export const candidateSearch = user => {
  return {
    type: CANDIDATE_SEARCH,
    payload: {user},
  }
}
export const candidateSearchListSuccessful = user => {
  return {
    type: CANDIDATE_SEARCH_SUCCESSFUL,
    payload: user,
  }
}

export const candidateSearchListFailed = user => {
  return {
    type: CANDIDATE_SEARCH_FAILED,
    payload: user,
  }
}
export const deleteCandidate = user => {
  return {
    type: CANDIDATE_DELETE,
    payload: { user },
  }
}
export const deleteCandidateSuccessful = user => {
  return {
    type: CANDIDATE_DELETE_SUCCESSFUL,
    payload: user,
  }
}
export const deleteCandidateFailed = user => {
  return {
    type:  CANDIDATE_DELETE_FAILED,
    payload: user,
  }
}

//candidate search list 

export const candidatesearchlist = user => {
  return {
      type: CANDIDATE_SEARCHLIST,
      payload: { user },
  }
}
export const candidatesearchlistSuccess = user => {
  return {
      type: CANDIDATE_SEARCHLIST_SUCCESS,
      payload:  user 
  }
}
export const candidatesearchlistFailed = candidatedata => {
  return {
      type: CANDIDATE_SEARCHLIST_ERROR,
      payload: { candidatedata },
  }
}


export const getSearchData = user => {
  return {
    type: GET_SEARCH_DATA,
    payload: { user },
  }
}
  export const getSearchCandidateData = user => {
    return {
      type: GET_SEARCH_CANDIDATE_DATA,
      payload: { user },
    }
  }
  export const mappedCandidateList = user => {
    return {
      type: GET_MAPPED_CANDIDATE_DATA,
      payload: { user },
    }
  }
  export const getMappedSearchData = user => {
    return {
      type: GET_SEARCH_MAPPED_CANDIDATE_DATA,
      payload: { user },
    }
  }
  export const getFilterSearchData = user => {
    return {
      type: GET_SEARCH_FILTER_CANDIDATE_DATA,
      payload: { user },
    }
  }
  export const getTableFilterSearchData = (user, customData) => {
    return {
      type:GET_TABLE_SEARCH_FILTER,
      payload: { user, customData },
    }
  }

  export const getSearchSuggestionData = user => {
    return {
      type: GET_SEARCH_SUGGESTION_DATA,
      payload: { user },
    }
  }

  export const getSearchTableData = user =>{
    return {
      type: GET_SEARCH_TABLE_SUGGESTION_DATA,
      payload: {user},
    }
  }

  export const getSearchSuggestionDataSuccess = user => {
    return {
        type: GET_SEARCH_SUGGESTION_DATA_SUCCESS,
        payload:  user 
    }
  }
  export const getSearchSuggestionDataFailed = candidatedata => {
    return {
        type: GET_SEARCH_SUGGESTION_DATA_ERROR,
        payload: { candidatedata },
    }
  }